<template>
    <div>
        <div class="signing-top">
            <div class="top">
                <div class="content">
                    <h1>{{ $t('review-sign.contract.headline') }}</h1>
                    <p>{{ getSigningPropertyAddress }}</p>
                </div>
                <button :disabled="updatingTenantInfo || !swornStatement" v-on:click="nextSigningStep" class="purple">
                    <span v-if="!updatingTenantInfo">{{ $t('notscreened.continue') }}</span>
                    <span v-if="updatingTenantInfo">{{ $t('notscreened.updating') }} ...</span>
                </button>
            </div>
            <div class="progress-bar">
                <div class="content">
                    <div class="col active">
                        <div class="dot"></div>
                        <p>{{ $t('review-sign.steps.info') }}</p>
                    </div>
                    <div class="col">
                        <div class="dot"></div>
                        <p>{{ $t('review-sign.steps.review') }}</p>
                    </div>
                    <div class="col" v-if="isPowerSupplyEnabled">
                        <div class="dot"></div>
                        <p>{{ $t('review-sign.steps.electricity') }}</p>
                    </div>
                    <div class="col">
                        <div class="dot"></div>
                        <p>{{ $t('review-sign.steps.sign') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="signing-content">
            <div class="content-box small">
                <div class="inputs">
                    <h2>{{ $t('review-sign.info.headline') }}</h2>
                    <p>{{ $t('review-sign.info.text') }}</p>
                    <br/>
                    <div class="row">
                        <div class="input-container">
                            <form><input type="text" name="" :placeholder="$t('input.placeholder.fullname')"
                                         v-model="fullName" autofill="off" autocomplete="false"></form>
                        </div>

                        <div class="input-container">
                            <form><input type="text" name="phone" :placeholder="$t('input.placeholder.phone')"
                                         v-model="phone"></form>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-container zip-code">
                            <form><input type="text" name="" :placeholder="$t('input.placeholder.zipcode')"
                                         v-model="currentZipcode" autofill="off" autocomplete="false"></form>
                        </div>
                        <div class="input-container">
                            <form><input type="text" name="" :placeholder="$t('input.placeholder.current-city')"
                                         v-model="currentCity" autofill="off" autocomplete="false"></form>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-container">
                            <form><input type="text" name="" :placeholder="$t('input.placeholder.current-address')"
                                         v-model="currentAddress" autofill="off" autocomplete="false"></form>
                        </div>
                    </div>
                    <div class="row" v-if="role_id === 2">
                        <p class="subject">{{ $t('review-sign.info.citizen') }}</p>
                        <div class="input-container select-field">
                            <div class="select-container small">
                                <select v-model="has_cpr">
                                    <option :value="true">{{ $t('global.label.yes') }}</option>
                                    <option :value="false">{{ $t('global.label.no') }}</option>
                                </select>
                                <span class="icon">
                                    <SvgIcon icon="select-arrow"/>
                                </span>
                            </div>
                        </div>
                        <div class="input-container">
                            <input type="text" name="cpr" v-model="cpr" :placeholder="$t('input.placeholder.cpr')"
                                   v-if="has_cpr === true" maxlength="10" pattern="[0-9]{10}">
                        </div>
                    </div>
                    <div v-if="role_id === 1">
                        <h3>{{ $t('digital.tabs.payments.bankdetails') }}</h3>
                        <div class="inputs data-input">
                            <div class="row">
                                <div class="input-container double">
                                    <form><input type="text" v-model="bankRegNo" autofill="off" autocomplete="false"
                                                 :placeholder="$t('bankRegNo')"></form>
                                </div>
                                <div class="input-container double">
                                    <form><input type="text" v-model="bankAccountNo" autofill="off" autocomplete="false"
                                                 :placeholder="$t('bankAccountNo')"></form>
                                </div>
                            </div>
                            <div class="input-container">
                                <form><input type="text" v-model="bankName" autofill="off" autocomplete="false"
                                             :placeholder="$t('bankName')"></form>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="button-container">
                            <label class="custom-checkbox">
                                <input type="checkbox" v-model="swornStatement">
                                <span class="checkbox">
									<svg xmlns="http://www.w3.org/2000/svg" width="9.895" height="7.38"
                                         viewBox="0 0 19.79 14.76">
									  <path class="fill-checkmark"
                                            d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z"
                                            transform="translate(-1311.12 -1083.12)"/>
									</svg>
								</span>
                                <p>{{ $t('review-sign.info.terms-text') }}</p>
                            </label>
                            <button :disabled="updatingTenantInfo || !swornStatement" v-on:click="nextSigningStep"
                                    class="purple">
                                <span v-if="!updatingTenantInfo">{{ $t('notscreened.continue') }}</span>
                                <span v-if="updatingTenantInfo">{{ $t('notscreened.updating') }} ...</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>


import {ROLE_TENANT} from '../../mixins/draft-contract';
import {mapGetters} from "vuex";
import Logo from '../../components/Logo';
import SvgIcon from '../../components/Svg.vue';

export default {
    data: () => ({
        swornStatement: false,
        updatingTenantInfo: false,
        fullName: '',
        email: '',
        phone: '',
        cpr: '',
        currentZipcode: '',
        currentCity: '',
        currentAddress: '',
        bankName: '',
        bankRegNo: '',
        bankAccountNo: '',
        role_id: null,
        has_cpr: true,
    }),
    components: {
        Logo,
        SvgIcon
    },
    computed: {
        ...mapGetters([
            'getToken',
            'getSigningPropertyAddress',
            'getSigningContractId',
            'getSingleDraftContract',
            'isPowerSupplyEnabled',
            'myId'
        ])
    },
    methods: {
        nextSigningStep() {
            this.updateTenantInfo();
        },
        updateTenantInfo() {
            var self = this;
            this.updatingTenantInfo = true;
            axios({
                method: 'PATCH',
                url: window.config.apiUrl + 'api/contract/' + this.$route.params.id + '/signature-info',
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    name: this.fullName,
                    email: this.email,
                    phone: this.phone,
                    zipcode: this.currentZipcode,
                    city: this.currentCity,
                    address: this.currentAddress,
                    bankRegNo: this.bankRegNo,
                    bankAccountNo: this.bankAccountNo,
                    bankName: this.bankName,
                    has_cpr: this.has_cpr,
                    cpr: this.cpr
                }
            }).then(response => {
                    // self.updatingTenantInfo = false;
                    this.$router.push('/signing-review/' + this.$route.params.id + '?review=1');
                    self.email = response.data.user.email;
                }
            ).finally((e) => {
                this.updatingTenantInfo = false;
            });
        },
        updatePowerSupplyState() {
            let primaryTenantId = _.find(this.getSingleDraftContract.tenants, {pivot: {is_primary: true}}).id;

            this.$store.commit('setPowerSupplyEnabled',
                this.getSingleDraftContract.contractData.electricityAccountingMode === 'third_party'
                && this.getSingleDraftContract.power_supply_enabled === true
                && this.has_cpr
                && primaryTenantId === this.myId
                && this.getSingleDraftContract.definition.rental_type != '2'
            )
        }
    },
    created() {
        axios({
            method: 'GET',
            url: window.config.apiUrl + 'api/contract/' + this.$route.params.id + '/signature-info',
            cancelToken: window.AuthorizationCancelSource.token
        }).then(response => {

            this.fullName = response.data.fullName;
            this.email = response.data.email;
            this.phone = response.data.phone;
            this.currentZipcode = response.data.currentZipcode;
            this.currentCity = response.data.currentCity;
            this.currentAddress = response.data.currentAddress;
            this.bankName = response.data.bankName;
            this.bankRegNo = response.data.bankRegNo;
            this.bankAccountNo = response.data.bankAccountNo;
            this.role_id = response.data.role_id;
            this.has_cpr = response.data.has_cpr;
        });

        this.$store.dispatch('fetchSingleDraftContract', {id: this.$route.params.id}).then(this.updatePowerSupplyState);
    },

    watch: {
        has_cpr: function () {
            this.updatePowerSupplyState();
        }
    }
}

</script>
<style></style>
